

<template>
  <v-container class="fill-height pa-0 ma-0 chat-drawer-container fluid">
    <template>
      <v-layout column>
        <v-flex sm12 class="white" v-if="dfbstore ? dfbstore.showContact : true">
          <ChatList/>
        </v-flex>
        <v-flex sm12 v-else>
          <ChatChannel/>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import ChatList from "../../components/Chat/ChatList";
import ChatChannel from "../../components/Chat/ChatChannel";
import { fbstore } from "../../config/fbstore";
export default {
  components: {
    ChatList,
    ChatChannel
  },
  data() {
    return {
      chat: null,
      selectedTab: null,
      dfbstore: fbstore
    };
  },
  computed: {
    showSidebar() {
      var a = fbstore.currentChan;
      return fbstore.currentChan == "";
    },
    showWindow() {
      var a = fbstore.currentChan;
      return fbstore.currentChan != "";
    }
  }
};
</script>
